module.exports = __webpack_public_path__ + "img/EN-GB.e499f1fb.png";